import { products as productsBase } from './products-config/base';
import { products as productsAT } from './products-config/AT';
import { products as productsCZ } from './products-config/CZ';
import { products as productsHU } from './products-config/HU';
import { products as productsHR } from './products-config/HR';
import { products as productsRO } from './products-config/RO';
import { products as productsSK } from './products-config/SK';
import { products as productsRS } from './products-config/RS';

export const ProductsFeatureConfig = {
    base: productsBase,
    AT: productsAT,
    CZ: productsCZ,
    HU: productsHU,
    HR: productsHR,
    RO: productsRO,
    SK: productsSK,
    RS: productsRS,
};
